
<div class="my-4"></div>
<div class="container text-primary" *transloco="let t">
  <div class="row my-4">
    <div class="col-12 col-lg-8 mb-4">
      <h1>Tu désires nous soutenir ?</h1>
      <div class="contact-question">
        <p class="mt-4 mb-2 fw-bold">Parce que, comme nous, tu penses que les activités de loisirs sont importantes pour la société et doivent être plus accessibles en ligne ?</p>
        <p class="my-3">L'association P.H.A.R.E. est une association à but non lucratif et accepte les soutiens financiers:</p>
<pre>
  Association P.H.A.R.E.
  2000 Neuchâtel
  CH78 0076 6000 1045 5711 1
</pre>
      </div>

      <h2>Sponsoring</h2>
      <p class="my-2 fw-bold">Tu représentes une organisation et désires soutenir le concept ? <a [routerLink]="routes.about">à propos</a></p>
      <a class="btn btn-primary" href="mailto:info@hopla.ch">
        Contacte-nous
      </a>
    </div>
  </div>
</div>
